import { all, put, call, takeEvery, takeLatest } from "redux-saga/effects";
import api_service from "../../network/api_callbacks";
import {
    GET_SHOW_REQUEST,
    getShowSuccess,
    getShowFailure
} from "../actions/getShows";

function* getShowsSaga(action) {
    try {
        const response = yield call(api_service.getShows, action.payload);
        yield put(getShowSuccess(response));
    } catch (err) {
        if (
            err?.code === 'ERR_NETWORK' ||
            err?.code === 'ERR_BAD_REQUEST' ||
            err?.code === 'ECONNABORTED'
        ) {
            yield put(getShowFailure(err?.message || 'Network error'));
        } else {
            yield put(getShowFailure(err?.response?.data?.message || 'Unknown error'));
        }
    }
}

export default function* watchGetShowSaga() {
    yield takeEvery(GET_SHOW_REQUEST, getShowsSaga);
}